import React, { useState, useEffect } from "react";
import OpenMenu from "../assets/menu_open.png";
import booking from "../assets/booking.svg";
import bookingOrng from "../assets/bookingOrng.svg";
import Guest from "../assets/sideGuestBlack.svg";
import Analytics from "../assets/sideAnalytisBlack.svg";
import Staff from "../assets/sideStaffBlack.svg";
import Website from "../assets/sideWebBlack.svg";
import Report from "../assets/sideReportBlack.svg";
import ReportOrng from "../assets/sideReportOrng.svg";
import HelpSupport from "../assets/sideHelpBlack.svg";
import GuestOrng from "../assets/sideGuestOrng.svg";
import AnalyticsOrng from "../assets/sideAnalyticsOrng.svg";
import StaffOrng from "../assets/sideStaffOrng.svg";
import WebsiteOrng from "../assets/sideWebOrng.svg";
import dropArroww from "../assets/dropArrow.svg";
import dropArrowwOrange from "../assets/dropArrowOrange.svg";
import HelpSupportOrng from "../assets/sideHelpOrng.svg";
import testiMonial from "../assets/testiMonial.svg";
import testiMonialorenge from "../assets/testiMonialOrg.svg";
import carMaint from "../assets/carMaint.svg";
import carMaintBlue from "../assets/carMaintBlue.svg";
import Ipass from "../assets/toll-road.png";
import IpassBlue from "../assets/toll-road (1).png";
import RapidCarLogo from "../assets/RapidCarLogo.png";
import MechanicBlack from "../assets/mechanicB.png";
import MechanicBlue from "../assets/mechanic1.png";
import "./Css/SideBar.css";
import { sidebarpagetext } from "./../CommonJquery/WebsiteText";
import { Link, useLocation } from "react-router-dom";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
import paymentIcon from "../assets/payment.svg"; // You'll need to add this icon
import paymentIconActive from "../assets/paymentActive.svg";
import leadManagement from "../assets/leadManagement.svg";
import leadManagementBlue from "../assets/leadManagementBlue.svg";
import {
  server_post_data,
  get_all_StaffRights,
} from "../ServiceConnection/serviceconnection.js";
function SideBar({ isSidebarOpen, toggleSidebar }) {
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const access_permission = retrieveData("access_permission");
  const [page_chekt, setPage_chekt] = useState([]);
  const [rightpage, setrightpage] = useState([]);
  const [designationpage, setDesignationPage] = useState([]);
  useEffect(() => {
    master_data_get_staff_right();
  }, []);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  /******************* this useEffect Staff Right Activity Start****************/
  useEffect(() => {
    var currentPage = window.location.pathname.split("/").pop();
    var rrr = Triosidebarhideshow(currentPage);
    if (rrr) {
      goback();
    }

    if (page_chekt[currentPage] && page_chekt[currentPage]["insidepage"]) {
      page_chekt[currentPage]["insidepage"].split("/").forEach(function (item) {
        console.log(item);
        const insidePages_vw = item.split("@");
        if (
          designationpage[currentPage] &&
          Object.values(designationpage[currentPage]).includes(
            insidePages_vw[0]
          )
        ) {
          // item is present in the designation so no need to remove
        } else {
          var elementsToRemove = document.querySelectorAll(
            "." + insidePages_vw[0]
          );
          elementsToRemove.forEach(function (element) {
            element.remove(); //remove buttons
          });
        }
      });
    }

    Object.keys(page_chekt).forEach(function (key) {
      var itempi = page_chekt[key].page_url_id;
      if (!designationpage[itempi]) {
        document.querySelectorAll(`li.${itempi}`).forEach(function (element) {
          element.remove();
        });
        document
          .querySelectorAll(`[href="/${itempi}"]`)
          .forEach(function (element) {
            element.remove();
          });
      }
    });
  }, [page_chekt]);

  /******************* this useEffect Staff Right Activity End ****************/

  const master_data_get_staff_right = async () => {
    const fd = new FormData();
    fd.append("flag", "10");
    await server_post_data(get_all_StaffRights, fd)
      .then((Response) => {
        // Assuming Response.data is an array of objects with 'page_url' as key
        Response.data.message.data.forEach(function (item) {
          var idd = item.page_url_id;
          setPage_chekt((prevState) => ({
            ...prevState,
            [idd]: {
              page_url_id: item.page_url_id,
              insidepage: item.insidepage,
            },
          }));
        });
        // Now you have page_chekt object in JavaScript

        const datam = access_permission.split("/");
        const newDataxt = datam.reduce((acc, item, index) => {
          if (item.includes("@")) {
            const [page, ...extras] = item.split("@");
            if (!acc[page]) {
              acc[page] = {};
            }
            extras.forEach((extra, idx) => {
              acc[page][idx] = extra;
            });
          } else {
            acc[item] = { ["class_list"]: "" };
          }
          return acc;
        }, {});
        setDesignationPage(newDataxt);

        if (Response.data.error) {
          //handleError(Response.data.message);
        } else {
          setrightpage(Response.data.message.data);
        }
      })
      .catch((error) => {});
  };

  function Triosidebarhideshow(pagelink) {
    if (designationpage[pagelink]) {
      return ""; // User has access to this page
    } else {
      if (!page_chekt[pagelink]) {
        return ""; // No user right for this page
      } else {
        return "dsplynoe"; // User has no right to access this page
      }
    }
  }

  /********* Current Page redirect Start**********/
  function goback() {
    window.history.back();
  }
  /********* Current Page redirect Close**********/
  return (
    <>
      {isSidebarOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
      <div className={`sidebar ${isSidebarOpen ? "OpneSidebar" : ""}`}>
        <div className="sidebar_container">
          <div className="sideHeadLogo">
            <a className="navbar-brand" href="#">
              <div className="headerLogo">
                <div className="headerLogo_contaienr">
                  <img src={RapidCarLogo} alt="Rapid Car" />
                </div>
              </div>
            </a>
          </div>
          <div
            data-bs-toggle="tooltip"
            data-bs-placement="left"
            htmlFor="top"
            title={`Hide`}
            className="menuOpenClose"
            onClick={toggleSidebar}
            style={{
              paddingLeft: "0",
              marginLeft: "2rem",
              justifyContent: "flex-start",
            }}
          >
            <img
              style={{ transform: " rotate(0deg)" }}
              src={OpenMenu}
              alt="Rapid Car Leasing"
            />
            {/* <p>{Hide_Menu_text}</p> */}
          </div>
          <div className="sidebar_list">
            <ul>
              <Link to="/Dashboard">
                <li className="dashboard">
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Dashboard"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Dashboard"
                          ? AnalyticsOrng
                          : Analytics
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>Dashboard</p>
                  </div>
                </li>
              </Link>
              <Link to="/Bookings">
                <li className={`reservation_mngmt`}>
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Bookings" ? "activeSideItem" : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Bookings"
                          ? bookingOrng
                          : booking
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>Bookings</p>
                  </div>
                </li>
              </Link>
              <Link to="/Maintanance">
                <li className={`reservation_mngmt`}>
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Maintanance"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Maintanance"
                          ? carMaintBlue
                          : carMaint
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>Maintenance</p>
                  </div>
                </li>
              </Link>
              <li className="dropdown sidebarDropdown payment_mngmt accounting_mngmt">
                <div
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className={`sidebar_list_item dropdown-toggle ${
                    location.pathname === "/payment-dashboard" ||
                    location.pathname === "/payment-ledger" ||
                    location.pathname === "/payment-reports"
                      ? "activeSideItem"
                      : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/payment-dashboard" ||
                      location.pathname === "/payment-ledger" ||
                      location.pathname === "/payment-reports"
                        ? paymentIconActive
                        : paymentIcon
                    }
                    alt="Rapid Car Leasing"
                  />
                  <p>Accounting</p>
                  <div className="droparrow">
                    <img
                      src={
                        location.pathname === "/payment-dashboard" ||
                        location.pathname === "/payment-ledger" ||
                        location.pathname === "/payment-reports"
                          ? dropArrowwOrange
                          : dropArroww
                      }
                      alt="img"
                    ></img>
                  </div>
                </div>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/payment-dashboard">
                      Payment Analytics
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/payment-ledger">
                      Account Ledger
                    </Link>
                  </li>

                  <li>
                    <Link className="dropdown-item" to="/payment-reports">
                      Weekly Reports
                    </Link>
                  </li>
                </ul>
              </li>
              <Link to="/Manage-Ipass">
                <li className={`reservation_mngmt`}>
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Manage-Ipass"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Manage-Ipass"
                          ? IpassBlue
                          : Ipass
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>I-Pass</p>
                  </div>
                </li>
              </Link>
              <Link to="/Customers">
                <li
                  className={`guest_mngmt ${Triosidebarhideshow(
                    "Guest_Management"
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Customers"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Customers" ? GuestOrng : Guest
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>Drivers</p>
                    {/* <p>{sidebarpagetext.Guest_Mgmt_text}</p> */}
                  </div>
                </li>
              </Link>
              <li className="dropdown sidebarDropdown staff_mngmt">
                <div
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className={`sidebar_list_item dropdown-toggle ${
                    location.pathname === "/View_Staff" ||
                    location.pathname === "/View_agent" ||
                    location.pathname === "/Add_Staff" ||
                    location.pathname === "/Add_agent" ||
                    location.pathname === "/View_Staff_Rights" ||
                    location.pathname === "/View_Sub_Rights" ||
                    location.pathname === "/View_Inside_Page_Rights" ||
                    location.pathname === "/Create_Staff_Rights" ||
                    location.pathname === "/Edit_Staff_Rights" ||
                    location.pathname === "/Edit_Sub_Rights" ||
                    location.pathname === "/Create_Inside_Page_Rights" ||
                    location.pathname === "/ViewDesignation" ||
                    location.pathname.includes("/edit_staff")
                      ? "activeSideItem"
                      : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/View_Staff" ||
                      location.pathname === "/View_agent" ||
                      location.pathname === "/Add_Staff" ||
                      location.pathname === "/Add_agent" ||
                      location.pathname === "/View_Staff_Rights" ||
                      location.pathname === "/View_Sub_Rights" ||
                      location.pathname === "/View_Inside_Page_Rights" ||
                      location.pathname === "/Create_Staff_Rights" ||
                      location.pathname === "/Edit_Staff_Rights" ||
                      location.pathname === "/Edit_Sub_Rights" ||
                      location.pathname === "/Create_Inside_Page_Rights" ||
                      location.pathname === "/ViewDesignation" ||
                      location.pathname.includes("/edit_staff")
                        ? StaffOrng
                        : Staff
                    }
                    alt="Rapid Car Leasing"
                  />
                  <p>{sidebarpagetext.Staff_Mgmt_text}</p>
                  <div className="droparrow">
                    <img
                      src={
                        location.pathname === "/View_Staff" ||
                        location.pathname === "/View_agent" ||
                        location.pathname === "/Add_Staff" ||
                        location.pathname === "/Add_agent" ||
                        location.pathname === "/View_Staff_Rights" ||
                        location.pathname === "/View_Sub_Rights" ||
                        location.pathname === "/View_Inside_Page_Rights" ||
                        location.pathname === "/Create_Staff_Rights" ||
                        location.pathname === "/Edit_Staff_Rights" ||
                        location.pathname === "/Edit_Sub_Rights" ||
                        location.pathname === "/Create_Inside_Page_Rights" ||
                        location.pathname === "/ViewDesignation" ||
                        location.pathname.includes("/edit_staff")
                          ? dropArrowwOrange
                          : dropArroww
                      }
                      alt="img"
                    ></img>
                  </div>
                </div>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/View_Staff">
                      View Staff
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/ViewDesignation">
                      View Designations
                    </Link>
                  </li>
                  {/* <li>
                    <Link className="dropdown-item" to="/View_agent">
                      View Agent
                    </Link>
                  </li> */}
                </ul>
              </li>
              <li className="dropdown sidebarDropdown fleet_mngmt">
                <div
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className={`sidebar_list_item dropdown-toggle ${
                    location.pathname === "/Car_Types" ||
                    location.pathname === "/view_cardetails" ||
                    location.pathname === "/view_new_guest_cars"
                      ? "activeSideItem"
                      : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/Car_Types" ||
                      location.pathname === "/view_cardetails" ||
                      location.pathname === "/view_new_guest_cars"
                        ? StaffOrng
                        : Staff
                    }
                    alt="Rapid Car Leasing"
                  />
                  <p>Fleet Mngmt</p>
                  <div className="droparrow">
                    <img
                      src={
                        location.pathname === "/Car_Types" ||
                        location.pathname === "/view_cardetails" ||
                        location.pathname === "/view_new_guest_cars"
                          ? dropArrowwOrange
                          : dropArroww
                      }
                      alt="img"
                    ></img>
                  </div>
                </div>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/Car_Types">
                      Car Types
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/view_cardetails">
                      Owned Cars
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/view_new_guest_cars">
                      New/Guest Cars
                    </Link>
                  </li>
                </ul>
              </li>
              <Link to="/Enquiries">
                <li
                  className={`guest_mngmt ${Triosidebarhideshow(
                    "Guest_Management"
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Enquiries"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Enquiries" ? GuestOrng : Guest
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>Enquiries</p>
                  </div>
                </li>
              </Link>
              <Link to="/Lead_Managment">
                <li
                  className={`guest_mngmt ${Triosidebarhideshow(
                    "Guest_Management"
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Lead_Managment"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Lead_Managment"
                          ? leadManagementBlue
                          : leadManagement
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>Lead Management</p>
                  </div>
                </li>
              </Link>
              <Link to="/acr_enquiries">
                <li
                  className={`guest_mngmt ${Triosidebarhideshow(
                    "Guest_Management"
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/acr_enquiries"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/acr_enquiries"
                          ? MechanicBlue
                          : MechanicBlack
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>Workhop Enquiries</p>
                  </div>
                </li>
              </Link>

              <li className="dropdown sidebarDropdown reports_mangmt">
                <div
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className={`sidebar_list_item dropdown-toggle ${
                    location.pathname === "/Booking_Reports" ||
                    location.pathname === "/Cars_Reports" ||
                    location.pathname === "/Maintanance_Reports"
                      ? "activeSideItem"
                      : " "
                  }`}
                >
                  <img
                    src={
                      location.pathname === "/Booking_Reports" ||
                      location.pathname === "/Cars_Reports" ||
                      location.pathname === "/Maintanance_Reports"
                        ? ReportOrng
                        : Report
                    }
                    alt="Rapid Car Leasing"
                  />
                  <p>Reports</p>
                  <div className="droparrow">
                    <img
                      src={
                        location.pathname === "/Booking_Reports" ||
                        location.pathname === "/Cars_Reports" ||
                        location.pathname === "/Maintanance_Reports"
                          ? dropArrowwOrange
                          : dropArroww
                      }
                      alt="img"
                    ></img>
                  </div>
                </div>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/Booking_Reports">
                      Booking Reports
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/Maintanance_Reports">
                      Maintanance Reports
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/Cars_Reports">
                      Cars Reports
                    </Link>
                  </li>
                </ul>
              </li>
              <Link to="/View_Testimonial">
                <li
                  className={`website_mngmt ${Triosidebarhideshow(
                    "Website_Management"
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/View_Testimonial"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/View_Testimonial"
                          ? testiMonialorenge
                          : testiMonial
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>Testimonial</p>
                  </div>
                </li>
              </Link>
              <Link to="/Website_Management">
                <li
                  className={`website_mngmt ${Triosidebarhideshow(
                    "Website_Management"
                  )}`}
                >
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Website_Management"
                        ? "activeSideItem"
                        : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Website_Management"
                          ? WebsiteOrng
                          : Website
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>{sidebarpagetext.Website_Mngmt}</p>
                  </div>
                </li>
              </Link>
              <Link to="/Manuals">
                <li className="Manuals">
                  <div
                    className={`sidebar_list_item ${
                      location.pathname === "/Manuals" ? "activeSideItem" : " "
                    }`}
                  >
                    <img
                      src={
                        location.pathname === "/Help_And_Support" ||
                        location.pathname === "/FAQs" ||
                        location.pathname === "/Manuals"
                          ? HelpSupportOrng
                          : HelpSupport
                      }
                      alt="Rapid Car Leasing"
                    />
                    <p>{sidebarpagetext.Help_Support_text}</p>
                  </div>
                </li>
              </Link>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default SideBar;
